module.exports = __webpack_public_path__ + "assets/images/magenta_sport_2_league.f8ce7cba90ab0880f47b378d57ff4989.png";